import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"slide-add"} maskId="square-filled-radius-0-stroke-1-IconSlideAdd"><path fillRule="evenodd" clipRule="evenodd" d="M2 17V2H17V7H22V22H7V17H2ZM16 3V7H7V16H3V3H16ZM15 11H14V14H11V15H14V18H15V15H17.8919V14H15V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSlideAdd;
